import styles from "../style.module.css";

export const Banner = () => {
	return (
		<section className={styles.banner_content}>
			<section className={styles.banner_text}>
				<h1>
					Coal City
					<br /> University Portal
				</h1>
				<p>
					Welcome to the Coal City University Portal. The Portal is
					designed to provide access to a wealth of campus resources
					and services in a centralised location.
				</p>
			</section>
		</section>
	);
};
